import { useState, useEffect } from 'react';
import { Stack } from '@mui/system';
import { Typography } from '@mui/material';
import { customComponentInternalProps } from 'components/FormCreatorComponent/types';

import { FormGroup } from '@mui/material';
import { BankAccount } from 'constants/bank-account.constants';
import BankAccountDetails from './BankAccountDetails';

import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface BankAccountsProps {
	accounts: BankAccount[];
	handleBankPick: any;
	selectedAccountId: number | null;
}

export default function BankAccountsDetails(props: customComponentInternalProps) {
	const bankAccountsProps: BankAccountsProps = props.cField.props.customData;
	const label: string = props.cField.props.label || '';
	const t = useAppSelector(selectTranslations);
	const [selectedAccountId, setSelectedAccountId] = useState<number>(0);

	const handleBankChoose = (id: number) => {
		setSelectedAccountId(id);
		props.handleChange({ target: { value: id } });
	};

	useEffect(() => {
		if (bankAccountsProps?.selectedAccountId) {
			setSelectedAccountId(bankAccountsProps.selectedAccountId);
		}
	}, [bankAccountsProps]);

	return (
		<Stack>
			<FormGroup sx={{ rowGap: '8px' }}>
				<Stack spacing={1}>
					<Typography>{t(label)}</Typography>

					{bankAccountsProps.accounts &&
						bankAccountsProps.accounts.map((account) => {
							return (
								<BankAccountDetails
									key={`bank-account-${account.id}`}
									account={account}
									isSelected={selectedAccountId === account.id}
									handleBankPick={handleBankChoose}
									disabled={props.cField.props.disabled || false}
								/>
							);
						})}
				</Stack>
			</FormGroup>
		</Stack>
	);
}
